<script setup>
import { ref, watch } from "vue";
import { useTriviaStore } from "@stores/trivia";

const triviaStore = useTriviaStore();

const active = ref(false);
const color = ref("");
const flashKey = ref(0);
let hideTimer = null;

watch(
    () => triviaStore.lastFeedback,
    (feedback) => {
        if (!feedback || !feedback.hex) return;
        clearTimeout(hideTimer);
        color.value = feedback.hex;
        flashKey.value++;
        active.value = true;

        hideTimer = setTimeout(() => {
            active.value = false;
        }, 1200);
    },
    { deep: true },
);
</script>

<template>
    <div
        v-if="active"
        :key="flashKey"
        class="feedback-flash"
        :style="{ '--flash-color': color }"
    />
</template>

<style scoped>
.feedback-flash {
    position: fixed;
    inset: 0;
    z-index: 10;
    pointer-events: none;
    background: radial-gradient(
        ellipse at center,
        transparent 20%,
        var(--flash-color) 150%
    );
    animation: flash 1.2s ease-out forwards;
}

@keyframes flash {
    0% {
        opacity: 0;
    }
    20% {
        opacity: 0.6;
    }
    100% {
        opacity: 0;
    }
}
</style>
